module.exports = __webpack_public_path__ + "static/media/education.6644cd11.png";